import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import CurrencyFormat from 'react-currency-format';

import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import Alert from '../../../components/Alert/Alert';
import ActionType from '../../../redux/reducer/globalActionType';
import IconCategoryIssueDelete from '../../../assets/icons/IconCategoryIssueDelete';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import API_COMMISSION_SCHEME from '../../../api/apiCommissionScheme';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_COMMISSION_INSERT, SETTING_COMMISSION_VIEW } from '../../../constants/menuPermissionConstant';

class CommissionScheme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailCommissionScheme: [],
            showConfirmSaveAlert: false,
            showConfirmDeleteAlert: false,
            selectedDeletedData: null,
            selectedDeletedDataIndex: null,
            levelCSOptions: {
                data: [],
                value: [],
            },
            disabledAddAndSave: true,
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.getLevelCSList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleAddCommissionScheme = () => {
        let commissionSchemeObject = {
            id: null,
            minPoint: 0,
            maxPoint: 0,
            checkInfinity: false,
            commission: 0,
            commissionSchemeIndex: this.state.detailCommissionScheme.length,
            showAlertMaxPointNotZero: false,
            showAlertMaxPointByMinPoint: false,
            action: 1,
            updatedAt: "",
        }

        if (this.state.detailCommissionScheme.length > 0) {
            if (this.checkMaxPointZero()) {
                return this.setState(prevState => ({
                    detailCommissionScheme: prevState.detailCommissionScheme.map(
                        obj => (obj.commissionSchemeIndex === (this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1], showAlertMaxPointNotZero: true }) : obj)
                    )
                }));
            }
            if (this.checkMaxPointWithMinPoint()) {
                return this.setState(prevState => ({
                    detailCommissionScheme: prevState.detailCommissionScheme.map(
                        obj => (obj.commissionSchemeIndex === (this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1], showAlertMaxPointByMinPoint: true }) : obj)
                    )
                }));
            }

            if (this.checkMaxPoint()) {
                return this.setState({
                    errorMessage: "Poin Maksimum harus lebih kecil dari 99999",
                    showErrorAlertResponse: true
                })
            }
            commissionSchemeObject = {
                id: null,
                minPoint: this.getAddMinPoin(),
                maxPoint: 0,
                checkInfinity: false,
                commission: 0,
                commissionSchemeIndex: this.state.detailCommissionScheme.length,
                showAlertMaxPointNotZero: false,
                showAlertMaxPointByMinPoint: false,
                action: 1,
                updatedAt: "",
            }
        }

        this.state.detailCommissionScheme.splice(this.state.detailCommissionScheme.length, 0, commissionSchemeObject);
        this.setState({ detailCommissionScheme: this.state.detailCommissionScheme });
    }

    handleDeleteCommissionScheme = (data, dataIndex) => {
        this.setState({ showConfirmDeleteAlert: false })
        if (data.action === 0 || data.action === 2) {
            return this.setState(prevState => ({
                detailCommissionScheme: prevState.detailCommissionScheme.map(
                    obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], action: 3 }) : obj)
                )
            }));
        }
        this.state.detailCommissionScheme.splice(dataIndex, 1);
        this.setState({ detailCommissionScheme: this.state.detailCommissionScheme, showConfirmDeleteAlert: false });
    }

    handleChangePoint = (event, data, dataIndex) => {
        if (event.target.value.length > 5) return alert('Tidak boleh lebih dari 5')
        let tempAction = data.action;
        let tempValue = event.target.valueAsNumber;
        if (event.target.value === "") {
            tempValue = event.target.value
        }
        if (data.action === 0) {
            tempAction = 2
        }
        if (event.target.value >= 0) {
            this.setState(prevState => ({
                detailCommissionScheme: prevState.detailCommissionScheme.map(
                    obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], showAlertMaxPointNotZero: false, showAlertMaxPointByMinPoint: false, action: tempAction }) : obj)
                )
            }));
        }
        if (event.target.value >= 0 && event.target.value <= 99999 && (dataIndex + 1) === this.state.detailCommissionScheme.length) {
            this.setState(prevState => ({
                detailCommissionScheme: prevState.detailCommissionScheme.map(
                    obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], [event.target.name]: tempValue, action: tempAction }) : obj)
                )
            }));
        }
        if (event.target.value >= 0 && event.target.value <= 99999 && (dataIndex + 1) < this.state.detailCommissionScheme.length) {
            this.setState(prevState => ({
                detailCommissionScheme: prevState.detailCommissionScheme.map(
                    obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], [event.target.name]: tempValue, action: tempAction }) : obj)
                )
            }),
                () => {
                    let totalData = this.state.detailCommissionScheme.length;
                    let totalDataActionThree = 0;
                    let totalDataActionOne = 0;
                    for (let i = 0; i < totalData; i++) {
                        if (this.state.detailCommissionScheme[i].action === 3) {
                            totalDataActionThree++;
                        }
                        if (this.state.detailCommissionScheme[i].action === 1) {
                            totalDataActionOne++;
                        }
                    }

                    if (totalDataActionThree > 0 && totalDataActionOne === 0) {
                        return
                    }

                    let tempActionNextData = this.state.detailCommissionScheme[dataIndex + 1 + totalDataActionThree].action;
                    if (this.state.detailCommissionScheme[dataIndex + 1 + totalDataActionThree].action === 0) {
                        tempActionNextData = 2
                    }

                    this.setState(prevState => ({
                        detailCommissionScheme: prevState.detailCommissionScheme.map(
                            obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex + 1 + totalDataActionThree) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex + 1 + totalDataActionThree], minPoint: this.state.detailCommissionScheme[dataIndex].maxPoint + 1, action: tempActionNextData }) : obj)
                        )
                    }));
                }
            );
        }
    }

    handleChangeCommission = (event, data, dataIndex) => {
        let tempAction = data.action;
        if (data.action === 0) {
            tempAction = 2
        }
        if (event.floatValue >= 0 && event.floatValue <= 999999999) {
            this.setState(prevState => ({
                detailCommissionScheme: prevState.detailCommissionScheme.map(
                    obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], commission: event.floatValue, action: tempAction }) : obj)
                )
            }));
        }
    }

    validationInput = event => {
        if ((event.floatValue >= 0 && event.floatValue <= 999999999) || isNaN(event.floatValue)) {
            return true;
        }
        return false;
    }

    handleCheckInfinity = (event, data, dataIndex) => {
        let tempAction = data.action;
        if (data.action === 0) {
            tempAction = 2
        }
        this.setState(prevState => ({
            detailCommissionScheme: prevState.detailCommissionScheme.map(
                obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], [event.target.name]: event.target.checked, action: tempAction }) : obj)
            )
        }),
            () => {
                if (this.state.detailCommissionScheme[dataIndex].checkInfinity) {
                    return this.setState(prevState => ({
                        detailCommissionScheme: prevState.detailCommissionScheme.map(
                            obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], maxPoint: 100000 }) : obj)
                        )
                    }));
                }
                this.setState(prevState => ({
                    detailCommissionScheme: prevState.detailCommissionScheme.map(
                        obj => (obj.commissionSchemeIndex === (data.commissionSchemeIndex) ? Object.assign(obj, { ...this.state.detailCommissionScheme[dataIndex], maxPoint: 0 }) : obj)
                    )
                }));
            }
        );
    }

    getAddMinPoin = () => {
        let totalData = this.state.detailCommissionScheme.length;
        let totalDataActionThree = 0;
        let totalDataActionOne = 0;
        for (let i = 0; i < totalData; i++) {
            if (this.state.detailCommissionScheme[i].action === 3) {
                totalDataActionThree++;
            }
            if (this.state.detailCommissionScheme[i].action === 1) {
                totalDataActionOne++;
            }
        }

        if (totalData === totalDataActionThree && totalDataActionOne === 0) {
            return 0;
        }

        if (totalDataActionThree > 0 && totalDataActionOne > 0) {
            return this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].maxPoint + 1;
        }

        return this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - (1 + totalDataActionThree)].maxPoint + 1;
    }

    checkMaxPointZero = () => {
        if (this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].maxPoint === 0 && this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].action !== 3) {
            return true;
        }
        return false;
    }

    checkMaxPointWithMinPoint = () => {
        if (this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].maxPoint <= this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].minPoint && this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].action !== 3) {
            return true;
        }
        return false;
    }

    checkMaxPoint = () => {
        if (this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].maxPoint === 99999 && this.state.detailCommissionScheme[this.state.detailCommissionScheme.length - 1].action !== 3) {
            return true;
        }
        return false;
    }

    checkBoxInfinityChecked = () => {
        if (this.state.detailCommissionScheme.length > 0) {
            for (const data of this.state.detailCommissionScheme) {
                if (data.checkInfinity && data.action !== 3) {
                    return true;
                }
            }
        }
        return false;
    }

    handleSave = () => {
        let dataIndex = 0;
        for (const data of this.state.detailCommissionScheme) {
            if (data.maxPoint <= data.minPoint && data.action !== 3) {
                return this.setState({
                    errorMessage: "Poin Maksimal yang Anda masukkan salah. Silahkan ubah Poin Maksimal",
                    showErrorAlertResponse: true
                })
            }
            if (this.showDeleteButton(this.state.detailCommissionScheme, dataIndex)) {
                if (!data.checkInfinity) {
                    return this.setState({
                        errorMessage: "Bracket komisi terakhir wajib memiliki poin maksimum tidak terbatas. Silakan ubah data Anda",
                        showErrorAlertResponse: true
                    })
                }
            }
            dataIndex++;
        }
        this.setState({ showConfirmSaveAlert: true });
    }

    handleSaveCommissionScheme = () => {
        const data = this.state.detailCommissionScheme.map((data) => {
            return {
                id: data.id,
                point_minimum: data.minPoint,
                point_maximum: data.maxPoint,
                commission: data.commission,
                updated_at: data.updatedAt,
                action: data.action,
            }
        })

        const wrapDataToCommissionScheme = { cs_level: this.state.levelCSOptions.value.value, cs_commission_list: data };
        API_COMMISSION_SCHEME.postCommissionScheme(wrapDataToCommissionScheme, this.props.token)
            .then(res => {
                this.setState({
                    detailCommissionScheme: [],
                    showConfirmSaveAlert: false,
                    showSuccessAlert: true,
                },
                    () => {
                        this.getCommissionByCSLevel(this.state.levelCSOptions.value.value);
                    }
                )
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleCancel = () => {
        this.setState({ detailCommissionScheme: [], levelCSOptions: { ...this.state.levelCSOptions, value: [] }, disabledAddAndSave: true })
    }

    getCommissionByCSLevel = csLevel => {
        API_COMMISSION_SCHEME.getCommissionByCSLevel(csLevel, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempCommission = getContent(res).map((commissionDetail, index) => ({
                        id: commissionDetail.id,
                        minPoint: commissionDetail.point_minimum,
                        maxPoint: commissionDetail.point_maximum,
                        checkInfinity: this.checkInfinityByPoint(commissionDetail.point_maximum),
                        commission: commissionDetail.commission,
                        commissionSchemeIndex: this.state.detailCommissionScheme.length + index,
                        showAlertMaxPointNotZero: false,
                        showAlertMaxPointByMinPoint: false,
                        updatedAt: commissionDetail.updated_at,
                        action: 0,
                    }));
                    let concatCommission = this.state.detailCommissionScheme.concat(tempCommission);
                    this.setState({ detailCommissionScheme: concatCommission, disabledAddAndSave: false });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({ disabledAddAndSave: true })
            }))
    }

    getLevelCSList = () => {
        API_COMMISSION_SCHEME.getLevelCSList(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempLevelCS = getContent(res).map(levelDetail => ({
                        value: levelDetail.remark,
                        label: levelDetail.description
                    }));
                    this.setState({ levelCSOptions: { ...this.state.levelCSOptions, data: tempLevelCS } });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleChangeCSLevel = e => {
        this.setState(
            {
                levelCSOptions: { ...this.state.levelCSOptions, value: e },
                detailCommissionScheme: [],
                disabledAddAndSave: true,
            },
            () => this.getCommissionByCSLevel(e.value)
        );
    }

    checkInfinityByPoint = value => {
        if (value === 100000) {
            return true;
        }
        return false;
    }

    showDeleteButton = (data, dataIndex) => {
        let totalData = data.length;
        let totalDataActionOne = 0;
        let totalDataActionThree = 0;
        for (let i = 0; i < totalData; i++) {
            if (data[i].action === 3) {
                totalDataActionThree++;
            }
            if (data[i].action === 1) {
                totalDataActionOne++;
            }
        }
        let tempIndex = dataIndex;
        if (totalDataActionThree > 0 && totalDataActionOne === 0) {
            tempIndex = tempIndex + totalDataActionThree;
        }
        if (data.length === tempIndex + 1) {
            return true
        }
        return false
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_COMMISSION_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="space-y-3">
                    {/* BREADCRUMBS */}
                    <div className="flex items-center text-gray-500 space-x-2">
                        <div>Pengaturan</div>
                        <FontAwesomeIcon icon={faAngleRight} />
                        <div className="font-semibold">Skema Komisi</div>
                    </div>

                    {/* TITLE */}
                    <div className="flex items-center text-3xl font-bold space-x-4">
                        <div>Skema Komisi</div>
                    </div>

                    {/* WHITECONTAINER */}
                    <div className="white-container pb-5">
                        <div className="w-full bg-white border border-gray-300 rounded-lg p-8 pb-10 space-y-10">
                            {/* FILTER PRODUCT & MODULE */}
                            <div className="space-y-4">
                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Level CS</p>
                                    </div>
                                    <Select
                                        inputId="ddlcslevel"
                                        name="level"
                                        options={this.state.levelCSOptions.data}
                                        placeholder="Pilih Level CS"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        maxMenuHeight={170}
                                        onChange={this.handleChangeCSLevel}
                                        value={this.state.levelCSOptions.value}
                                    />
                                </div>
                            </div>

                            {/* CONTENT */}
                            <div className="space-y-6">
                                <CheckPermissionComponent permissionConstant={[SETTING_COMMISSION_INSERT]} userPermission={this.props.userDetail.permissions}>
                                    {/* HEADER CONTENT */}
                                    <div className="flex justify-between items-center">
                                        <button id="btnaddnewschema"
                                            onClick={this.handleAddCommissionScheme}
                                            className=
                                            {`
                                            flex items-center text-white py-2 px-6 rounded-lg 
                                            ${this.checkBoxInfinityChecked() || this.state.disabledAddAndSave ? "bg-gray-500 cursor-default" : "bg-olddarkblue cursor-pointer"}
                                        `}
                                            disabled={this.checkBoxInfinityChecked() || this.state.disabledAddAndSave}
                                        >
                                            <IconAddTransparent />
                                            <span className="ml-2">Poin & Komisi</span>
                                        </button>
                                    </div>
                                </CheckPermissionComponent>

                                {/* DETAIL CATEGORY ISSUE */}
                                <div className="space-y-5">
                                    {this.state.detailCommissionScheme.map((data, index) =>
                                        <div key={`detail-category-issue-${index}`} className={`flex w-full
                                            ${this.state.detailCommissionScheme[index].action === 3 && "hidden"}
                                        `}>
                                            <div className="flex w-full items-center space-x-10">
                                                <div className="w-2/12 relative">
                                                    <div className="flex font-bold">
                                                        <p className="mr-1">Poin Minimal</p>
                                                        <span className="text-darkred">*</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        name="minPoint"
                                                        className="form-control-second w-full"
                                                        placeholder="0"
                                                        minLength={0}
                                                        maxLength={99999}
                                                        value={data.minPoint}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="w-2/12 relative">
                                                    <div className="flex font-bold">
                                                        <p className="mr-1">Poin Maksimal</p>
                                                        <span className="text-darkred">*</span>
                                                    </div>
                                                    <input
                                                        id="tslpointmax"
                                                        type="number"
                                                        name="maxPoint"
                                                        className={`form-control-second w-full ${data.checkInfinity && "hidden"}`}
                                                        placeholder="0"
                                                        value={data.maxPoint}
                                                        onChange={(e) => this.handleChangePoint(e, data, index)}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="maxPointInfinity"
                                                        className={`form-control-second w-full ${!data.checkInfinity && "hidden"}`}
                                                        value={"∞"}
                                                        disabled
                                                    />
                                                    <div className={`absolute -bottom-9 ${!this.state.detailCommissionScheme[index].showAlertMaxPointByMinPoint && "hidden"}`}>
                                                        <MasterDataUserAlert text="Poin Maksimal harus lebih besar dari Poin Minimal" />
                                                    </div>
                                                    <div className={`absolute -bottom-5 ${!this.state.detailCommissionScheme[index].showAlertMaxPointNotZero && "hidden"}`}>
                                                        <MasterDataUserAlert text="Minimal 1" />
                                                    </div>
                                                </div>
                                                <div className="w-3/12">
                                                    <div className="flex justify-center mt-6 space-x-3">
                                                        <input
                                                            id="ckbinfinite"
                                                            type="checkbox"
                                                            name="checkInfinity"
                                                            className="h-6 w-6 border"
                                                            onChange={(e) => this.handleCheckInfinity(e, data, index)}
                                                            disabled={this.showDeleteButton(this.state.detailCommissionScheme, index) ? false : true}
                                                            checked={data.checkInfinity}
                                                        />
                                                        <label className="text-xl text-gray-600 font-medium">Poin Tidak Terbatas</label>
                                                    </div>
                                                </div>
                                                <div className="w-3/12">
                                                    <div className="flex font-bold">
                                                        <p className="mr-1">Komisi yang didapatkan</p>
                                                        <span className="text-darkred">*</span>
                                                    </div>
                                                    <div className="relative">
                                                        <div className="flex h-full w-12 absolute justify-center items-center bg-gray-300 rounded-l-md">
                                                            IDR
                                                        </div>
                                                        <CurrencyFormat
                                                            id="tslcommision"
                                                            className="form-control-currency pl-14"
                                                            min={0}
                                                            max={999999999}
                                                            value={data.commission}
                                                            displayType={"input"}
                                                            thousandSeparator={"."}
                                                            decimalSeparator={','}
                                                            isAllowed={(e) => this.validationInput(e)}
                                                            onValueChange={(e) => this.handleChangeCommission(e, data, index)}
                                                        />
                                                    </div>
                                                </div>
                                                <CheckPermissionComponent permissionConstant={[SETTING_COMMISSION_INSERT]} userPermission={this.props.userDetail.permissions}>
                                                    <div className={`${this.showDeleteButton(this.state.detailCommissionScheme, index) ? "flex justify-center mt-6 w-10" : "hidden"}`}>
                                                        <div id="btndelete" className="cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, selectedDeletedData: data, selectedDeletedDataIndex: index })}>
                                                            <IconCategoryIssueDelete />
                                                        </div>
                                                    </div>
                                                </CheckPermissionComponent>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <CheckPermissionComponent permissionConstant={[SETTING_COMMISSION_INSERT]} userPermission={this.props.userDetail.permissions}>
                        {/* Button */}
                        <div className="flex justify-end space-x-5 pb-5">
                            <button id="btncancel" className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={this.handleCancel}>Batal</button>
                            <button id="btnsave" className={`text-white py-2 px-6 rounded-lg font-medium ${this.state.disabledAddAndSave ? "bg-gray-500 cursor-default" : "bg-olddarkblue cursor-pointer"}`}
                                onClick={this.handleSave}
                                disabled={this.state.disabledAddAndSave ? true : false}
                            >
                                Simpan</button>
                        </div>
                    </CheckPermissionComponent>
                </div>

                <Alert show={this.state.showConfirmSaveAlert} button={true} title="Simpan Poin & Komisi?" desc={"Apakah Anda yakin ingin menyimpan data?"} close={() => this.setState({ showConfirmSaveAlert: false })} submit={() => this.handleSaveCommissionScheme()} />
                <Alert show={this.state.showConfirmDeleteAlert} button={true} title="Hapus Poin & Komisi?" desc={"Apakah Anda yakin ingin menghapus Poin & Komisi?"} close={() => this.setState({ showConfirmDeleteAlert: false, selectedDeletedData: null, selectedDeletedDataIndex: null })} submit={() => this.handleDeleteCommissionScheme(this.state.selectedDeletedData, this.state.selectedDeletedDataIndex)} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil di Simpan"} close={() => this.setState({ showSuccessAlert: false })} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionScheme);